var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWithLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208496,
    y: 0.791565,
    width: 50,
    height: 50,
    rx: 25,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8344 16.7016C34.6687 13.5358 29.536 13.5358 26.3702 16.7016L13.7444 29.3274L25.2085 40.7916L37.8344 28.1657C41.0001 25 41.0001 19.8673 37.8344 16.7016ZM25.2085 32.8696L21.6664 29.3274L30.3312 20.6626C30.9695 20.0243 31.7149 19.929 32.1023 19.929C32.4898 19.929 33.2351 20.0243 33.8734 20.6626C34.5117 21.3009 34.607 22.0463 34.607 22.4337C34.607 22.8211 34.5116 23.5664 33.8734 24.2048L25.2085 32.8696Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5825 16.7015C9.44395 19.8401 9.41759 24.9116 12.5022 28.0833L23.9643 16.6212C20.7926 13.5366 15.721 13.563 12.5825 16.7015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWithLove);
export default __webpack_public_path__ + "static/media/ic_with_love.c8351f60efd4ef3c1b84cb31945defc8.svg";
export { ForwardRef as ReactComponent };